import { JsEnum } from '@meta-vue/util'
import { TsEnum } from '@meta-vue/util-ts'
// 工作台类型
export const WB_TYPE = {
  IN: 'callin',
  OUT: 'callout',
  SM: 'simulate',
  IM: 'im',
  MY_TEM_SAVE: 'my_tem_save', // 我的暂存
  MY_SERVICE_ORDER: 'my_service_order', // 我的服务单
  COMMON: 'common'
}

/**
 * 会话状态枚举
 */
export const CONVERSATION_STATUS = new JsEnum([
  ['待处理，代码流转使用', -1, 'NO_STATUS'],
  ['排队中', 1, 'WAITING'],
  ['会话中', 2, 'ON_GOING'],
  ['客服主动结束会话', 3, 'NORMAL_FINISH'],
  ['排队中结束会话', 4, 'ABNORMAL_FINISH'],
  ['未回复结束会话', 5, 'UN_REPLY_FINISH'],
  ['未排队结束会话', 6, 'UN_WAIT_FINISH'],
  ['转接结束会话', 7, 'TRANSFER_FINISH'],
  ['智能客服结束会话', 8, 'AI_FINISH'],
  ['系统结束会话', 9, 'SYSTEM_FINISH'],
  ['休眠', 11, 'SLEEP']
])

/**
 * IM 消息来源枚举
 */
export const IM_MSG_SOURCEMAP = new JsEnum([
  ['未知', 0, 'unknown'],
  ['自发', 1, 'user'],
  ['系统', 2, 'system']
])

/**
 * im 客服平台枚举
 */
export const IM_WORKBENCH_MAP = new JsEnum([
  ['在线客服', '1001', 'ONLINE_IM'],
  ['电话客服', 2, 'ONLINE_CALL'],
  ['企业客服', 90005424, 'ENTERPRISE_IM'],
  ['零担客服', 90007111, 'PARTLOAD_IM'],
  ['保险客服', 90007571, 'INSURANCE_IM']
])

/**
 * im 消息base valid状态枚举
 * 0 无效 1 有效 2 已删除 3 已撤回
 */
export const IM_MSG_VALID = new JsEnum([
  ['无效', 0, 'isInvalid'],
  ['有效', 1, 'isValid'],
  ['已删除', 2, 'isDel'],
  ['已撤回', 3, 'isWithdraw']
])

/**
 * 枚举文件支持格式
 * @type {{pptx: {thumbnail: string, contains: [string]}, pdf: {thumbnail: string, contains: [string]}, ppt: {thumbnail: string, contains: [string, string]}, doc: {thumbnail: string, contains: [string, string, string]}, xls: {thumbnail: string, contains: string[]}}}
 */
export const mediaFileType = {
  ppt: {
    thumbnail: 'PPT@3x.png',
    contains: ['ppt', 'pptx']
  },
  doc: {
    thumbnail: 'WORD@3x.png',
    contains: ['doc', 'docx']
  },
  xls: {
    thumbnail: 'EXCEL@3x.png',
    contains: ['xls', 'xlsx']
  },
  pdf: {
    thumbnail: 'PDF@3x.png',
    contains: ['pdf']
  }
}

/**
 * im场景码枚举
 */
export const im_scene_source = new JsEnum([
  ['TMS', '5E1DDC11', 'tms']
  // ['满运宝', 'C7EE7D99', 'myb'], // 需求定制化，满运宝无需显示
])

/**
 * 小结单状态
 */
export const SERVICE_TICKET_STATUS = new JsEnum([
  ['未创建', -1, 'notCreate'],
  ['暂存', 1, 'tempSave'],
  ['保存关闭', 2, 'saveAndClose'],
  ['保存转办', 3, 'saveAndTransfer']
])

/**
 * 小结单可提交状态  1:可提交 2:转接结束不可提交（被转接会话） 3:转接来源不可提交 (转接后的会话)
 */
export const SERVICE_TICKET_SUMMIT_STATUS = new JsEnum([
  ['可提交', 1, 'CanSubmit'],
  ['转接结束不可提交（被转接会话）', 2, 'DisableSubmitA'],
  ['转接来源不可提交 (转接后的会话)', 3, 'DisableSubmitB']
])

/**
 * IM消息类型 msg.base.type
 */
export const IM_MSG_COMPONENT_TYPE = new JsEnum([
  ['文本消息', 'txt', 'TXT'],
  ['图片', 'img', 'IMG'],
  ['位置', 'loc', 'LOC'],
  ['语音', 'audio', 'AUDIO'],
  ['卡片消息', 'card', 'CARD'],
  ['视频', 'video', 'VIDEO'],
  ['文件', 'file', 'FILE'],
  ['透传消息', 'cmd', 'CMD']
])

/**
 * IM卡片类型枚举
 */
export const IM_CARD_TYPE = new JsEnum([
  ['邀评', 'invite_comment', 'INVITE_COMMENT'],
  ['邀评', 'invite_comment_new', 'INVITE_COMMENT_NEW'],
  ['主动邀评', 'invite_comment_automatic', 'INVITE_COMMENT_AUTOMATIC'],
  ['主动邀评', 'invite_comment_automatic_new', 'INVITE_COMMENT_AUTOMATIC_NEW'],
  ['热线邀评', 'hotline_im_comment', 'HOTLINE_IM_COMMENT'],
  ['结束会话', 'finish_conversation', 'FINISH_CONVERSATION'],
  ['智能推荐文章列表', 'knowledge_list', 'KNOWLEDGE_LIST'],
  ['智能推荐卡片', 'intelligent_recommend_type', 'INTELLIGENT_RECOMMEND_TYPE'],
  ['智能推荐文章详情', 'knowledge_detail', 'KNOWLEDGE_DETAIL'],
  ['转接人工客服', 'trans_service', 'TRANS_SERVICE'],
  ['智能推荐类目', 'consult_type_list', 'CONSULT_TYPE_LIST'],
  ['投诉单列表', 'complaintList', 'COMPLAINT_LIST'],
  ['智能选择卡片', 'intelligent_card', 'INTELLIGENT_CARD'],
  ['区域客服主动推送文本', 'contact_call', 'CONTACT_CALL'],
  ['还贷提醒', 'repay_remind_card', 'REPAY_REMIND_CARD'],
  ['智能客服', 'confirm_trans_service', 'CONFIRM_TRANS_SERVICE'],
  ['订单文章', 'order_knowledge', 'ORDER_KNOWLEDGE'],
  ['预约回呼', 'reservation_callback', 'RESERVATION_CALLBACK'],
  ['智能推荐文章卡片', 'knowledge_card', 'KNOWLEDGE_CARD'],
  ['阵地卡片', 'position_card', 'POSITION_CARD'],
  ['文章卡片', 'article_directory_card', 'ARTICLE_DIRECTORY_CARD'],
  ['邀评卡片', 'ocs_evaluate_card', 'OCS_EVALUATE_CARD']
])

/**
 * 消息已读/未读 状态 msgStatus
 */
export const IM_MSG_READ_STATUS = new JsEnum([
  ['未读', 1, 'UNREAD'],
  ['已读', 2, 'HAVE_READ']
])

/**
 * 用户身份会员标识 状态 identity
 * https://wiki.amh-group.com/pages/viewpage.action?pageId=252159450
 */
export const USER_IDENTITY_STATUS = new TsEnum([
  ['普通会员', 1, 'COMMON'],
  ['付费会员', 2, 'VIP']
])

/**
 * 用户标签 userTagList 枚举 （提示类，暂时未使用）
 * https://wiki.amh-group.com/pages/viewpage.action?pageId=252151469
 */
export const USER_TAGS = new TsEnum([
  ['付费VIP司机', 10001, 'VIP'],
  ['城市先锋', 10002, 'CITY_PIONEER'],
  ['城市精英', 10003, 'CITY_ELITE'],
  ['城市英雄', 10004, 'CITY_HERO'],
  ['城市王者', 10005, 'CITY_KING'],
  ['司机权益灰度标签', 10006, 'DRIVER_EGT'] // Driver equity grayscale tag
])

/**
 * 用户进线来源
 * https://wiki.amh-group.com/pages/viewpage.action?pageId=263119392
 */
export const USER_PLATFORM_SOURCE = new JsEnum([
  ['其他', 0, '其他'],
  ['YMM', 1, 'YMM'],
  ['HCB', 2, 'HCB'],
  ['ETC', -1, 'ETC']
])

/**
 * 应答类型
 */
export const SEARCH_TYPE = new TsEnum([
  ['文章知识', 0, 'ARTICLE'],
  ['任务型技能', 1, 'TASK'],
  ['问题库', 3, 'PROBLEM']
])

/**
 * 用户角色
 */
export const USER_ROLE = new JsEnum([
  ['未知', 0, 'UNKNOWN'],
  ['司机', 1, 'DRIVER'],
  ['货主', 2, 'SHIPPER'],
  ['企业管理员', 3, 'ENTERPRISE_ADMIN'],
  ['双角色', 999, 'All'],
  ['ETC代理', 6, 'ETC']
])

/**
 * 应用端枚举
 * >> 统一问题预测中心
 */
export const APPLY_SCENES = new TsEnum([
  ['在线客服', 0, 'IM'],
  ['智能IVR', 1, 'IVR']
])

/**
 * 小结单模板业务查询组件 field 前缀
 * 模板表单约定前缀值，不可修改
 * @type {string}
 */
export const FORM_BIZ_SEARCH_FIELD_PREFIX = '$$BIZ_'

/**
 * app版本检测
 */
export const APP_CHECK_SCENE = new TsEnum([['SOP', 1, 'SOP']])

/**
 * im周边配置枚举
 * 1,2,3,4每个对应一个页面
 * https://wiki.amh-group.com/pages/viewpage.action?pageId=281861442
 */
export const IM_CONFIG_CODE = new TsEnum([
  ['会话分配设置', 1, 'ALLOCATION'],
  ['会话超时设置', 2, 'TIMEOUT'],
  ['基础设置', 3, 'BASIC'],
  ['直连人工配置', 4, 'ART']
])

export const USER_ACCOUNT_STATUS = new TsEnum([
  ['注销', -2, 'LOGOUT'],
  ['已认证', 1, 'CERTIFIED'],
  ['未认证', 0, 'NOT_CERTIFIED']
])

// 用户画像tab枚举， 数字对应后端枚举，不可更改
export const WORKBENCH_MODULE_TYPE = new TsEnum([
  ['服务信息', 1, 'SERVE'],
  ['交易信息', 2, 'TRANSACTION'],
  ['用户信息', 3, 'USER'],
  ['资产信息', 4, 'PROPERTY'],
  ['知识库', 5, 'KNOWLEDGE'],
  ['SOP聚合信息', 6, 'SOP'],
  ['用户信息（客验）', 7, 'ADVANCED_USER'], // 重构的用户信息模块
  ['常用信息', 101, 'COMMON'], // 101 前端自定义 对应 topSchema 配置
  ['智能推荐', 102, 'INTELLIGENCE'], // 102 前端自定义 对应 relationSchema 配置
  ['人工通话记录', 103, 'RECORD'] // 103 前端自定义
])

/**
 * SOP系统变量
 */
export const SOP_CONSTANT = new JsEnum([
  ['投诉单号', 'COMPLAINT_CASE_ID', '_COMPLAINT_CASE_ID'],
  ['订单ID', 'ORDER_ID', '_ORDER_ID'],
  ['账号列表', 'PERSONAL_ACCOUNT_LIST', '_PERSONAL_ACCOUNT_LIST'],
  ['运费贷款列表', 'FREIGHT_DISBURSEMENTS_LOAN_LIST', '_FREIGHT_DISBURSEMENTS_LOAN_LIST'],
  ['订单贷款列表', 'ORDER_LOAN_LIST', '_ORDER_LOAN_LIST'],
  ['账单贷款列表', 'BILL_LOAN_LIST', '_BILL_LOAN_LIST'],
  ['加油订单列表', 'OIL_ORDER_LIST', '_OIL_ORDER_LIST'],
  ['费用单列表', 'FEE_APPLY_RECORD_LIST', '_FEE_APPLY_RECORD_LIST']
])

export const WAYBILL_TAGS = new TsEnum([
  ['全能保障', 1, 'ALL_PROTECTION'],
  ['预警异常', 2, 'EARLY_WARNING'],
  ['订金垫付权益', 3, 'DEPOSIT_ADVANCES']
])

// 小结单特殊类型处理
export const DISTYPES = ['yupload', 'CxUpload', 'ycascader']

// 行为分状态枚举和质量分状态枚举
export const BehaviorScoreStatusEnum = new TsEnum([
  ['不可申诉', -1, 'DISABLED'],
  ['待申诉', 0, 'TODO'],
  ['申诉中', 1, 'DOING'],
  ['申诉成功', 2, 'SUCCESS'],
  ['申诉失败', 3, 'FAIL']
])

// 货源状态
export const CargoStatusEnum = new TsEnum([
  ['已下单', 10, 'CREATED'],
  ['审核中', 11, 'ON_AUDITING'],
  ['审核不通过', 13, 'AUDITING_NOT_PASS'],
  ['待上架', 15, 'NOT_ON_SHELVES'],
  ['找车中', 20, 'SEARCH'],
  ['复核状态', 24, 'DOUBLE_CHECK'],
  ['匹配到车', 30, 'MATCHED'],
  ['超时下架', 40, 'EXPIRED'],
  ['已下架', 50, 'OFF_SHELVES'],
  ['已完成', 90, 'DONE'],
  ['已取消', -1, 'CANCEL']
])

// 货源类型
export const CargoTypeEnum = new TsEnum([
  ['普通货源', 0, 'CARGO_0'],
  ['满运宝交易货源', 1, 'CARGO_1'],
  ['企业满运宝货源', 2, 'CARGO_2'],
  ['企业精选满运宝', 3, 'CARGO_3'],
  ['个人精选满运宝', 4, 'CARGO_4'],
  ['个人普通精选货源', 5, 'CARGO_5'],
  ['企业普通精选货源', 7, 'CARGO_7'],
  ['满运宝普票', 8, 'CARGO_8'],
  ['拼车货源', 9, 'CARGO_9']
])

export const CUSTOMER_ROLE = new JsEnum([
  ['司机', 1, 'DRIVER'],
  ['货主', 2, 'SHIPPER']
])
// 呼叫类型
export const CallTypeEnum = new TsEnum([
  ['呼入', 1, 'CALL'],
  ['呼出', 2, 'EXHALATION'],
  ['转接', 3, 'TRANSFER'],
  ['双呼', 4, 'DOUBLE_CALL'],
  ['AI外呼转人工', 5, 'AI_TRANSFER_ARTIFICIAL']
])

// 呼叫接听状态
export const CallAnswerStatus = new TsEnum([
  ['接听', 1, 'ANSWER'],
  ['未接听', 2, 'NO_ANSWER']
])

// 预约回呼创建来源
//  1:app 2:客诉工作台 3:95进线（系统） 4:95进线人工 5:im进线（人工）
export const ReserveCallBackSource = new TsEnum([
  ['app', 1, 'APP'],
  ['客诉工作台', 2, 'COMPLAINT'],
  ['95进线系统', 3, 'CALL_SYSTEM'],
  ['95进线人工', 4, 'CALL_IN'],
  ['im进线人工', 5, 'IM'],
  ['模拟弹屏手工创建', 6, 'SIMULATE']
])

// 预约回呼状态
export const ReserveCallBackStatus = new TsEnum([
  ['待处理', 1, 'TODO'],
  ['处理中', 2, 'HANDLE'],
  ['已关闭', 3, 'CLOSED'],
  ['已取消', 4, 'CANCEL']
])

// 沟通模板组件类型映射
export const ELE_FORM_ITEM_TYPE = {
  radio: 'yradio',
  input: 'yinput',
  textarea: 'ytextarea',
  date: 'ydatepicker',
  datetime: 'ydatetimepicker',
  checkbox: 'ycheckbox',
  select: 'yselect',
  'crm-image-uploader': 'yupload',
  CxUpload: 'CxUpload',
  'sop-input': 'sop-input',
  ServiceStandard: 'ServiceStandard',
  SummaryComplaints: 'summary-complaints'
}

export const WORKBENCH_CALL_TYPE = {
  CALL_IN: 1, //  电话呼入
  CALL_OUT: 2, // 电话呼出
  CALL_IM: 3, // 手工创建
  CALL_ONLINE: 4, //在线接待 （被动接待）
  CALL_ONLINE_ACTIVE: 5, // 在线主动接待（从历史会话发起的）
  CALL_ONLINE_CONTACT: 6, // 在线主动联系
  CALL_OUT_TASK: 7, // 任务外呼
  AVAYA_CALL_IN: 8 // 电话呼入（avaya）
}

// 运单支付佣金状态枚举项
export const orderPayStatusEnums = new TsEnum([
  ['未支付', 0, 'UN_PAY'],
  ['已支付到收款方', 1, 'PAYED'],
  ['已退款', 2, 'PAY_BACK'],
  ['支付中', 5, 'PAYING'],
  ['已支付到平台', 10, 'PAYED_PLATFORM'],
  ['确认中', 15, 'PAY_CONFIRMING'],
  ['部分退款', 20, 'PAY_PART_BACK'],
  ['退款中', 25, 'PAY_BACKING'],
  ['支付失败', -1, 'PAY_FAILED']
])

// 重开投诉单行为类型枚举
export const ReopenComplaintHandlerType = new TsEnum([
  ['不做操作', 0, 'NO_ACTION'], // 取消操作
  ['链接跳转', 1, 'LINK_JUMP'], // 跳转且不创建投诉单
  ['继续当前操作', 2, 'CONTINUE_CURRENT_ACTION'] //继续且创建投诉单
])

// sop 操作类型枚举
export const SOP_OPERATE_TYPE_ENUM = new TsEnum([['同步会话中运单', 1, 'syncOrder']])

// 在线工作台 - 商品货源卡片类型枚举
export const IM_CARD_GOODS_TYPE = new TsEnum([
  ['货源', 'cargo', 'CARGO'],
  ['运单', 'order', 'ORDER']
])

// 运单成交模式枚举
export const BARGAIN_DEAL_TYPE_ENUM = new TsEnum([
  ['普通', 0, 'NORMAL'],
  ['报价', 1, 'BARGAIN'],
  ['一口价', 2, 'BUYOUTPRICE'],
  ['议价', 3, 'BARGAINING'],
  ['定价（短途）', 5, 'SHORT'],
  ['定价（长途）', 6, 'LONG'],
  ['承运商定价', 7, 'CARRIERPRICE'],
  ['一口价（快车）', 8, 'KUAICHE'],
  ['一口价（成交率）', 9, 'CLOSE_RATE'],
  ['定价(整车)', 10, 'FULL_VEHICLE'],
  ['报价（快车）', 11, 'BARGAIN_KUAICHE'],
  ['委托货源', 12, 'BARGAIN_ENTRUST'],
  ['拼车', 13, 'SHARE_CAR'],
  ['电议（整车）', 14, 'ELECTRICITY_DISS_FULL'],
  ['拼货货源', 15, 'SPELL_GOODS'],
  ['零担专线', 16, 'PART_LOAD_SPECIAL']
])

/**
 * 转办对象配置：0:默认;1客诉; 4:创新 5:加油 6:一键报警
 * */
export const TRANSFER_CONFIGURATION_TYPE = new TsEnum([
  ['满帮家工单', 0, 'DEFAULT_CASE_TYPE'],
  ['客诉单', 1, 'COMPLAINT_CASE_TYPE'],
  ['申诉工作台（创新）', 4, 'INNOVATION_CASE_TYPE'],
  ['申诉工作台（加油）', 5, 'REFUEL_CASE_TYPE'],
  ['一键报警工单', 6, 'ALARM_CASE_TYPE'],
  ['仲裁单', 7, 'ARBITRATION_CASE_TYPE'],
  ['短途业务进线问题工单', 8, 'SD_ENTRY_ORDER'],
  ['待补充凭证工单', 10, 'SUPPLEMENTARY_DOCUMENT_WORK']
])

/**
 * 获取用户信息接口 状态
 * */
export const CUSTOMERINFO_STATUS = new TsEnum([
  ['加载中', 'loading', 'loading'],
  ['加载成功', 'success', 'success'],
  ['加载失败', 'failed', 'failed']
])

/**
 * 交易单类型['ORDER', 'COMPLAINT', 'NEGOTIATION', 'INSURANCE']
 */
export const TradeTypes = new JsEnum([
  ['运单号', 'orderNo', 'ORDER'],
  ['投诉单号', 'complaintNo', 'COMPLAINT'],
  ['纠纷协商单号', 'negotiationNo', 'NEGOTIATION'],
  ['保险单号', 'insuranceNo', 'INSURANCE']
])

export const callListEnum = new TsEnum([
  ['呼入', 1, 'CALL'],
  ['呼出', 2, 'EXHALATION'],
  ['转接', 3, 'TRANSFER'],
  ['双呼', 4, 'DOUBLE_CALL'],
  ['AI外呼转人工', 5, 'AI_TRANSFER_ARTIFICIAL']
])

/**
 * 纠纷协商单类型枚举
 */
export const caseTypeEnum = new TsEnum([
  ['协商单', 1, 'NEGOTIATE'],
  ['纠纷单', 2, 'DISPUTE']
])

// SOP 助手tab 枚举
export const SOP_HELPER_TAB_ENUM = new TsEnum([
  ['确认场景', 1, 'SCENE'],
  ['确认单据', 2, 'INVOICES'],
  ['确认诉求', 3, 'APPEAL'],
  ['解决方案', 4, 'SOLUTION'],
  ['服务小结', 5, 'RECORD_FORM']
])

export const LOCALE_STORE_KEY = '__i18n_current_locale'
